import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { ConfigService } from 'src/app/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(public http: HttpClient, public config: ConfigService) {}

  /** Helper method to build safe HttpHeaders and prevent null/undefined errors */
  private getHeaders(customHeaders: { [key: string]: any } = {}): HttpHeaders {
    const defaultHeaders: { [key: string]: any } = {
      'Content-Type': 'application/json',
      'access_token': this.config.accessToken || '',
      'userId': this.config.userId ? String(this.config.userId) : '',
      'IspId': this.config.projectIspId ? String(this.config.projectIspId) : '',
      'location': this.config.projectLocation ? JSON.stringify(this.config.projectLocation) : '',
      'area': this.config.projectArea ? String(this.config.projectArea) : '',
      ...customHeaders
    };

    let headers = new HttpHeaders();
    Object.keys(defaultHeaders).forEach((key) => {
      const val = defaultHeaders[key];
      // Only set headers that have valid, non-null string values
      if (val !== null && val !== undefined && val !== '') {
        headers = headers.set(key, String(val));
      }
    });

    return headers;
  }

  getCountryCode(screenName: string) {
    const params = {
      "pageUrl": "ListOfCountryCode",
      "entityName": "Country_MsT",
      "action": "payload",
      "event": "replaceWithAuth",
      "formData": {
        "isActive": 1,
        "isApprove": 1
      }
    };

    const options = {
      headers: this.getHeaders({
        'event': screenName || '',
        'pageUrl': 'ListOfCountryCode',
        'action': 'Get list of country code'
      })
    };

    return this.http.post((this.config.url || '') + '?tenantId=' + (this.config._tid || ''), params, options);
  }

  fetchOTP(phoneNum: any, countryCode: any, screenName: string) {
    const params = {
      "mobilePhone": phoneNum,
      "country_Code": countryCode ? countryCode.toString() : ''
    };

    const options = {
      headers: this.getHeaders({
        'event': screenName || '',
        'pageUrl': 'loginViaOTPVersionfourFYND',
        'action': 'On Login - verify OTP'
      })
    };

    return this.http.post(
      this.config.baseUrl + '/ipos/rest/FYND/loginViaOTPVersionfourFYND?tenantId=' + this.config._tid + '&user_App_ID=' + this.config.appCode,
      params,
      options
    );
  }

  verifyMobile(mobileNumber: any, countryCode: any) {
    const params = {
      "mobile": mobileNumber,
      "countryCode": countryCode ? countryCode.toString() : ''
    };

    const options = {
      headers: this.getHeaders({
        'event': 'Login',
        'pageUrl': 'CheckMobileAvailableForLogin',
        'action': 'Verify mobile number'
      })
    };

    return this.http.post(this.config.baseUrl + '/ipos/rest/FYND/CheckMobileAvailableForLogin?tenantId=' + this.config._tid, params, options);
  }

  verifyMobileSocialSignup(mobileNumber: any, countryCode: any, screenName: string) {
    const params = {
      "mobile": mobileNumber,
      "countryCode": countryCode ? countryCode.toString() : ''
    };

    const options = {
      headers: this.getHeaders({
        'event': screenName || '',
        'pageUrl': 'CheckMobileAvailablev2',
        'action': ' Check mobile number available'
      })
    };

    return this.http.post(this.config.baseUrl + '/ipos/rest/FYND/CheckMobileAvailablev2?tenantId=' + this.config._tid, params, options);
  }

  loginWithOTPOld(otp: any) {
    const params = {
      "code": otp ? otp.toString() : '',
      "to": this.config.mobNumber,
      "country_Code": this.config.countryCode
    };

    const options = { headers: this.getHeaders() };
    return this.http.post(
      this.config.baseUrl + '/ipos/rest/FYND/verifyOTPForLoginVersionfourFYND?tenantId=' + this.config._tid + '&user_App_ID=' + this.config.appCode + '&twoFactor=' + this.config.twoFactor + '&userId=' + this.config.userCode,
      params,
      options
    );
  }

  loginWithPasswordOld(password: any) {
    const params = {
      "password": password,
      "loginId": this.config.partyEmail,
    };

    const options = { headers: this.getHeaders() };
    return this.http.post(this.config.baseUrl + '/ipos/rest/FYND/login5?tenantId=' + this.config._tid, params, options);
  }

  fetchMalls(screenName: string) {
    const params = {
      "pageUrl": "ListOfMallForFynd",
      "entityName": "Oken_Onboarding",
      "action": "payload",
      "event": "replaceWithAuth",
      "formData": {
        "oko_Cat_Desc": "Mall",
        "oko_Status": 1,
        "branch_Status": 1
      }
    };

    const options = {
      headers: this.getHeaders({
        'event': screenName || '',
        'pageUrl': "ListOfMallForFynd",
        'action': "Fetch Malls"
      })
    };

    return this.http.post((this.config.url || '') + '?tenantId=' + (this.config._tid || ''), params, options);
  }

  verifyEmailId(email: string) {
    const params = { "email": email };
    const options = { headers: this.getHeaders() };
    return this.http.post(this.config.baseUrl + '/ipos/rest/FYND/CheckEmailAvailableV2?tenantId=' + this.config._tid + '&user_App_ID=' + this.config.appCode, params, options);
  }

  sendOTPForSignUp(phoneNum: any, countryCode: any, screenName: string) {
    const params = {
      "formList": [
        {
          "country_Code": parseInt(countryCode),
          "to": parseInt(phoneNum)
        }
      ]
    };

    const options = {
      headers: this.getHeaders({
        'event': screenName || '',
        'pageUrl': "signUpsmsversionsix",
        'action': "Send otp for signup"
      })
    };

    return this.http.post(this.config.baseUrl + '/ipos/rest/bpm/signUpsmsversionsix?tenantId=' + this.config._tid, params, options);
  }

  verifyOTPforSignUp(otp: any, userData: any) {
    const params = {
      "formList": [
        {
          "country_Code": parseInt(userData["countryCode"]),
          "otp": parseInt(otp),
          "to": parseInt(userData["mobNumber"])
        }
      ]
    };

    const options = {
      headers: this.getHeaders({
        'event': "Verify Otp",
        'pageUrl': "verifysignupotpversionfour",
        'action': "Verify otp for signup"
      })
    };

    return this.http.post(this.config.baseUrl + '/ipos/rest/bpm/verifysignupotpversionfour?tenantId=' + this.config._tid, params, options);
  }

  signUPold(password: any, userData: any) {
    const gender = userData.gender != null ? userData.gender.toString() : null;

    const params = {
      "user": {
        "password": password,
        "preferredLanguages": ["en", "fr"],
        "data": {
          "birthDate": userData.dob ? userData.dob : null,
          "country_Code": userData.countryCode ? userData.countryCode.toString() : '',
          "displayName": userData.userFullName,
          "favoriteColors": ["Red", "Blue"],
          "userDOA": userData.anniversary ? userData.anniversary : null,
          "userGender": gender
        },
        "email": userData.email,
        "firstName": userData.firstName,
        "fullName": userData.userFullName,
        "imageUrl": "",
        "lastName": userData.lastName,
        "mobilePhone": userData.mobNumber,
        "username": userData.mobNumber,
        "usernameStatus": "PENDING"
      }
    };

    const options = { headers: this.getHeaders() };
    return this.http.post(this.config.baseUrl + '/ipos/rest/FYND/SignUpInFusionauthVersionFYND?tenantId=' + this.config._tid + '&user_App_ID=' + this.config.appCode + '&isAuthReq=0&branch_Code=' + this.config.userSelectedMallCode, params, options);
  }

  socialLogin(params: any) {
    const socialFlow = localStorage.getItem('social');
    const options = {
      headers: this.getHeaders({
        'event': 'Social Login',
        'pageUrl': socialFlow === 'Google' ? 'callBackHtmlForFYNDV1' : 'callBackHtmlForAppleFYNDV1',
        'action': 'Social login callback'
      })
    };

    if (socialFlow === 'Google') {
      return this.http.get(this.config.baseUrl + '/ipos/rest/fusionAuth/callBackHtmlForFYNDV1?code=' + params.code + '&state=' + this.config._tid + '%26isMobile=4%26user_App_ID=' + this.config.appCode, options);
    } else {
      return this.http.get(this.config.baseUrl + '/ipos/rest/fusionAuth/callBackHtmlForAppleFYNDV1?code=' + params.code + '&state=' + this.config._tid + '%26isMobile=4%26user_App_ID=' + this.config.appCode, options);
    }
  }

  addSocialNumber() {
    const params = {};
    const options = {
      headers: this.getHeaders({
        'userId': this.config.registerId ? String(this.config.registerId) : ''
      })
    };
    return this.http.post((this.config.url || '') + '?tenantId=' + (this.config._tid || ''), params, options);
  }

  verifySocialNumber() {
    const params = {};
    const options = {
      headers: this.getHeaders({
        'userId': this.config.registerId ? String(this.config.registerId) : ''
      })
    };
    return this.http.post((this.config.url || '') + '?tenantId=' + (this.config._tid || ''), params, options);
  }

  redirectURLOld(params: any) {
    const options = { headers: this.getHeaders() };
    return this.http.post(this.config.baseUrl + '/ipos/rest/FYND/SOSURLV2?tenantId=' + this.config._tid, params, options);
  }

  verifyOTPforSocialSignUpOld(otp: any, userData: any) {
    const params = {
      "formList": [
        {
          "country_Code": userData.countryCode ? userData.countryCode.toString() : '',
          "otp": otp,
          "mobile": userData.mobileNumber,
          "userId": userData.userId,
          "email": userData.email
        }
      ]
    };

    const options = { headers: this.getHeaders() };
    return this.http.post(this.config.baseUrl + '/ipos/rest/FYND/verifySocialsignupotpFYND?tenantId=' + this.config._tid, params, options);
  }

  loginWithPassword(password: any) {
    const params = {
      "password": password,
      "loginId": this.config.partyEmail,
      "redirectParam": this.config.redirectParam ? this.config.redirectParam : ""
    };

    const options = { headers: this.getHeaders() };
    return this.http.post(this.config.baseUrl + '/ipos/rest/FYND/login5?tenantId=' + this.config._tid, params, options);
  }

  loginWithOTP(otp: any) {
    const params = {
      "code": otp ? otp.toString() : '',
      "to": this.config.mobNumber,
      "country_Code": this.config.countryCode,
      "redirectParam": this.config.redirectParam ? this.config.redirectParam : ""
    };

    const options = { headers: this.getHeaders() };
    return this.http.post(
      this.config.baseUrl + '/ipos/rest/FYND/verifyOTPForLoginVersionfourFYND?tenantId=' + this.config._tid + '&user_App_ID=' + this.config.appCode + '&twoFactor=' + this.config.twoFactor + '&userId=' + this.config.userCode,
      params,
      options
    );
  }

  signUP(password: any, userData: any) {
    const gender = userData.gender != null ? userData.gender.toString() : null;

    const params = {
      "user": {
        "password": password,
        "preferredLanguages": ["en", "fr"],
        "data": {
          "birthDate": userData.dob ? userData.dob : null,
          "countryCode": userData.countryCode ? userData.countryCode.toString() : '',
          "displayName": userData.userFullName,
          "favoriteColors": ["Red", "Blue"],
          "userDOA": userData.anniversary ? userData.anniversary : null,
          "userGender": gender
        },
        "email": userData.email,
        "firstName": userData.firstName,
        "fullName": userData.userFullName,
        "imageUrl": "",
        "lastName": userData.lastName,
        "mobilePhone": userData.mobNumber,
        "username": userData.mobNumber,
        "usernameStatus": "PENDING"
      }
    };

    const options = {
      headers: this.getHeaders({
        'redirectParam': this.config.redirectParam ? this.config.redirectParam : '',
        'event': "Verify Otp",
        'pageUrl': "SignUpInFusionauthVersionFYND",
        'action': "Signup"
      })
    };

    return this.http.post(
      this.config.baseUrl + '/ipos/rest/FYND/SignUpInFusionauthVersionFYND?tenantId=' + this.config._tid + '&user_App_ID=' + this.config.appCode + '&isAuthReq=0&branch_Code=' + this.config.userSelectedMallCode,
      params,
      options
    );
  }

  verifyOTPforSocialSignUp(otp: any, userData: any) {
    const params = {
      "formList": [
        {
          "country_Code": userData.countryCode ? userData.countryCode.toString() : '',
          "otp": otp,
          "mobile": userData.mobileNumber,
          "userId": userData.userId,
          "email": userData.email,
          "redirectParam": this.config.redirectParam ? this.config.redirectParam : "",
          "mallcode": userData.mallCode,
          ...this.config.genderobj,
          ...this.config.dobobj
        }
      ]
    };

    const options = { headers: this.getHeaders() };
    return this.http.post(this.config.baseUrl + '/ipos/rest/FYND/verifySocialsignupotpFYND?tenantId=' + this.config._tid, params, options);
  }

  redirectURL(params: any, screenName: string) {
    const options = {
      headers: this.getHeaders({
        'event': screenName || '',
        'pageUrl': "SOSURLV2",
        'action': "Redirect URL"
      })
    };

    return this.http.post(this.config.baseUrl + '/ipos/rest/FYND/SOSURLV2?tenantId=' + this.config._tid, params, options);
  }

  fetchOTPV2(phoneNum: any, countryCode: any, teleCode: any, screenName: string) {
    const params = {
      "countryCode": countryCode ? countryCode.toString() : '',
      "to": phoneNum ? phoneNum.toString() : '',
      "teleCode": teleCode ? teleCode.toString() : ''
    };

    const options = {
      headers: this.getHeaders({
        'event': screenName || '',
        'pageUrl': 'loginSignUPSendOTPVersion7',
        'action': 'On Login - get OTP'
      })
    };

    return this.http.post(this.config.baseUrl + '/ipos/rest/FYND/loginSignUPSendOTPVersion7?tenantId=' + this.config._tid, params, options);
  }

  loginWithOTPV2(otp: any) {
    const params = {
      "code": otp ? otp.toString() : '',
      "to": this.config.mobNumber,
      "country_Code": this.config.countryCode,
      "redirectParam": this.config.redirectParam ? this.config.redirectParam : ""
    };

    const options = {
      headers: this.getHeaders({
        'event': 'Login With OTP',
        'pageUrl': 'verifyOTPFYND',
        'action': 'On Login - verify OTP'
      })
    };

    return this.http.post(this.config.baseUrl + '/ipos/rest/FYND/verifyOTPFYND?tenantId=' + this.config._tid, params, options);
  }

  signUpByUser(countryCode: any, mobNumber: any, mallCode: any) {
    const params = {
      "user": {
        "data": {
          "countryCode": parseInt(countryCode),
          "defaultMallCode": mallCode ? mallCode.toString() : '',
          "source": "FYND"
        },
        "mobilePhone": mobNumber
      }
    };

    const options = {
      headers: this.getHeaders({
        'redirectParam': this.config.redirectParam ? this.config.redirectParam : '',
        'event': "Select Mall",
        'pageUrl': "SignUpFYND",
        'action': "Sign up by user"
      })
    };

    return this.http.post(this.config.baseUrl + '/ipos/rest/FYND/SignUpFYND?tenantId=' + this.config._tid + '&user_App_ID=' + this.config.appCode, params, options);
  }

  verifyOTPforSocialSignUpV2(otp: any, userData: any, screenName: string) {
    const params = {
      "pageUrl": "verifysignupotpsocial",
      "formList": [
        {
          "country_Code": userData.countryCode ? userData.countryCode.toString() : '',
          "to": userData.mobileNumber,
          "otp": otp,
          "party_Email": userData.email,
          "userName": userData.userName,
          "userId": userData.userId
        }
      ]
    };

    const options = {
      headers: this.getHeaders({
        'event': screenName || '',
        'pageUrl': 'verifyandupdatemobileFYND',
        'action': 'On Login - verify OTP for social signup'
      })
    };

    return this.http.post(this.config.baseUrl + '/ipos/rest/FYND/verifyandupdatemobileFYND?tenantId=' + this.config._tid, params, options);
  }

  socialsignUpWthMall(mallCode: any, userData: any) {
    const params = {
      "pageUrl": "verifysignupotpsocial",
      "formList": [
        {
          "partyId": Number(userData.partyId),
          "userId": Number(userData.userId),
          "branch_Code": mallCode
        }
      ]
    };

    const options = {
      headers: this.getHeaders({
        'event': 'Social signin select mall',
        'pageUrl': 'AllocatemallFYND',
        'action': 'Social sign up by user with mall'
      })
    };

    return this.http.post(this.config.baseUrl + '/ipos/rest/fusionAuth/AllocatemallFYND?tenantId=' + this.config._tid, params, options);
  }
}